import React from 'react';

import TextField from '@mui/material/TextField';
import type { AutocompleteRenderInputParams } from '@mui/material';

import { inputStyle } from '../styles';

const DebouncedTextField: React.FC<{
  onChange: (str: string) => void;
  params: AutocompleteRenderInputParams;
  onBlur?: React.FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  placeholder?: string;
  name?: string;
  delay?: number;
}> = ({ delay = 300, ...props }) => {
  const [searchString, setSearchString] = React.useState<string>('');

  const timeOutId = React.useRef<NodeJS.Timeout | undefined>();

  React.useEffect(() => {
    clearTimeout(Number(timeOutId.current));
    timeOutId.current = setTimeout(() => props.onChange(searchString), delay);
  }, [searchString]);
  return (
    <TextField
      variant="standard"
      placeholder={props.placeholder ?? ''}
      {...props.params}
      fullWidth
      style={inputStyle}
      onBlur={props.onBlur}
      InputProps={{
        ...props.params.InputProps,
        disableUnderline: true,
        style: {
          color: "#5C5D68",
        },
      }}
      onChange={(ev) => setSearchString(ev.target.value)}
      name={props.name || ''}
    />
  );
};

export default DebouncedTextField;
